import Announcements from '@admin/components/announcements'
import Page from '@admin/components/page'

const mapPropsToPage = (props, context, resources) => ({
  title: 't(Announcements)',
  component: Announcements
})

export default Page(null, mapPropsToPage)
